// extracted by mini-css-extract-plugin
module.exports = {"fakeBookWrapper":"FakeVerticalBookCard__fakeBookWrapper","arrow":"FakeVerticalBookCard__arrow"};